export default __webpack_public_path__ + "static/Icono-energia-en-materiales-ab98c64101c9c8073c28661ee6497896.png";